module.exports = __webpack_public_path__ + "static/media/spinner.b95289c6.gif";